/** Date style for excursion rows in both modal variants, which must stay visually identical. */
export const EXCURSION_DATE_FORMAT = "MMM dd, yyyy";

export const columnsConfig = [
  {
    id: "id",
    header: "",
    size: 60,
    type: "checkbox",
    getColumnDisplayValue: () => "",
  },
  {
    id: "eventname",
    header: "Event Name",
    size: 400,
    getColumnDisplayValue: ({ title }) => title || "",
  },
  {
    id: "category_name",
    header: "Category",
    size: 400,
    getColumnDisplayValue: ({ category_name }) => category_name || "",
  },
  {
    id: "duration",
    header: "Duration",
    size: 200,
    getColumnDisplayValue: ({ duration }) => duration,
  },
  {
    id: "location",
    header: "Location",
    size: 200,
    getColumnDisplayValue: ({ location }) => location || "",
  },
  {
    id: "departurecity",
    header: "Departure City",
    size: 200,
    getColumnDisplayValue: ({ departure_city, departure_city_country_id }) =>
      [departure_city, departure_city_country_id].filter(Boolean).join(", ") || "",
  },
  {
    id: "startdateandtime",
    header: "Start Date & Time",
    size: 200,
    getColumnDisplayValue: ({ start_date, start_date_time, start_date_timezone }) =>
      [start_date, start_date_time, start_date_timezone].filter(Boolean).join(" ") || "",
  },
  {
    id: "organizedby",
    header: "Organized By",
    size: 200,
    getColumnDisplayValue: ({ host }) => host,
  },
  {
    id: "product_price",
    header: "Price",
    size: 200,
    getColumnDisplayValue: ({ product_price }) => product_price,
  },
];

export const ERROR_MESSAGE = "An error occurred when trying to update excursions data. Please try again.";

export const tableHeaders = ["Excursions Name", "Duration", "Date & Time", "Price", "Status"];
